import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetCounterDeliveriesProps } from "@/services/counter-delivery.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber, isEmpty, parseTonInputToNumber } from "@/utils/query-string";

export interface CDFRProps {
  order_date?: Dayjs;
  account_number: Option;
  order_amount: string;
  grain: number;
  ton: number;
  estados?: number[];
}

export const getCounterDeliveriesFilter = (
  event: CDFRProps,
): Partial<GetCounterDeliveriesProps> => {
  let order_amount: number | undefined;
  let tonValue: number | undefined;

  if (event?.order_amount) {
    const num = formatCurrencyInputToNumber(event.order_amount);

    if (!Number.isNaN(num)) {
      order_amount = Number(num.toFixed(2));
    }
  }

  tonValue = parseTonInputToNumber(event?.ton);

  return {
    ...(event?.order_date && dayjs(event?.order_date).isValid()
      ? {
          fecha: dayjs(event?.order_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
    ...(event?.account_number
      ? {
          nroCuenta: String(event?.account_number?.value),
        }
      : {}),
    ...(event?.order_amount && order_amount
      ? {
          monto: order_amount,
        }
      : {}),
    ...(isEmpty(tonValue)
      ? {}
      : {
          toneladas: tonValue,
        }),
    ...(event.grain
      ? {
          grano: event?.grain,
        }
      : {}),
  };
};
